import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


ReactDOM.render(
  <div>
    <App rootElement = {document.getElementById('root')}/>
    <div id = "creator">Creator : Mena Agina</div>
  </div>,

  document.getElementById('root')
);


